import Grid from '@blocks/Grid'
import Table from '@modules/Table'
import { Box, Container } from '@styles/helpers'
import { tablet } from '@styles/mixins'
import { grid } from '@styles/vars'
import React from 'react'
import { useParams } from 'react-router-dom'
import { Column } from 'react-table'
import styled, { css } from 'styled-components'
import { ReactComponent as ChevronIcon } from '@icons/chevron.svg'
import Button from '@blocks/Button'
import { route } from '@helpers'
import useTitle from '@hooks/useTitle'
import useSalon from '@general/models/Salon'
import useSalonController from '@general/api/useSalonController'

export default function SalonStatusPage() {
    const { slug } = useParams<{ slug: string }>()
    const salon = useSalon(slug)

    const controller = useSalonController()
    const status = controller.status(slug).use()

    const name = salon.state?.name || "Loading..."
    useTitle(`Status List: ${name}`)

    if (!salon.state) 
        return null

    if (!status.data)
        return null
    
    return (
        <SalonStatusContainer>
            <Grid>
                <Grid gap="20px">
                    <Button type="tertiary" scheme="outline" to={route("general:salon", slug)} icon={<ChevronStyledIcon />}>Back</Button>
                    <Grid gap="10px">
                        <h1>Status List</h1>
                        <h2 className="h3">{salon.state.name}</h2>
                    </Grid>
                </Grid>
                <Box narrow>
                    <Table data={status.data} columns={columns} />
                </Box>
            </Grid>
        </SalonStatusContainer>
    
    )
}

// OPTIONS
const columns: Column<General.Resources.StatusCustomer>[] = [
    {
        Header: 'Name',
        accessor: 'name'
    },
    {
        Header: 'Country',
        accessor: row => row.country.name
    },
    {
        Header: 'Status',
        accessor: 'paid',
        Cell: ({ value }) => value ? 'Paid' : 'Not paid'
    }
]

// STYLES
const SalonStatusContainer = styled(Container)`
    padding-top: ${grid.margins.phone};
    padding-bottom: ${grid.margins.phone};

    ${tablet(css`
        padding-top: ${grid.margins.tablet};
        padding-bottom: ${grid.margins.tablet};
    `)}
`

const ChevronStyledIcon = styled(ChevronIcon)`
    display: block;
    transform: rotate(90deg);
`